/**
 * Converts a number to Indian currency words format
 * Properly handles Indian denominations (crores, lakhs, thousands, hundreds)
 * @param num - The number to convert to words
 * @returns The number in words with 'Rupees' at the end
 */
export const convertNumberToIndianWords = (num: number): string => {
  if (num === 0) return 'Zero Rupees';
  
  // Round to nearest rupee
  num = Math.round(num);
  
  const single = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  // Function to convert numbers from 1-99
  const convert2Digits = (n: number): string => {
    if (n < 10) return single[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + single[n % 10] : '');
  };
  
  let words = '';
  
  // Handle crores (10 million)
  if (num >= 10000000) {
    words += convert2Digits(Math.floor(num / 10000000)) + ' Crore ';
    num %= 10000000;
  }
  
  // Handle lakhs (100 thousand)
  if (num >= 100000) {
    words += convert2Digits(Math.floor(num / 100000)) + ' Lakh ';
    num %= 100000;
  }
  
  // Handle thousands
  if (num >= 1000) {
    words += convert2Digits(Math.floor(num / 1000)) + ' Thousand ';
    num %= 1000;
  }
  
  // Handle hundreds
  if (num >= 100) {
    words += single[Math.floor(num / 100)] + ' Hundred ';
    num %= 100;
  }
  
  // Handle tens and units
  if (num > 0) {
    // Add 'and' for values less than 100 when there are higher denominations
    if (words !== '') {
      words += 'and ';
    }
    words += convert2Digits(num);
  }
  
  return words.trim() + ' Rupees';
};
